// A space restricts request access by pinning it to master-data rows.
// `masterToRestrictAccess` used to hold a single "<dataId>::<column>" string; it
// now holds a list of { dataId, column }. Both shapes are read here so the rest
// of the app only ever sees the list.
export const readMasterRestrictions = (space) => {
  const value = space?.masterToRestrictAccess
  if (Array.isArray(value)) {
    return value
      .filter(restriction => restriction?.dataId)
      .map(restriction => ({ dataId: restriction.dataId, column: restriction.column || "Name" }))
  }
  const raw = value || ""
  if (!raw) return []
  const [dataId, legacyColumn] = raw.split("::")
  if (!dataId) return []
  return [{ dataId, column: space?.masterColumnToRestrict || legacyColumn || "Name" }]
}
